import TestResponseItem from './TestResponseItem';
import { TestResponseItemProps, TestResponseItemValueProps } from './types';

export type { TestResponseItemProps, TestResponseItemValueProps };
export default TestResponseItem;
